var _style, _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 360 360",
    style: {
      enableBackground: "new 0 0 360 360"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.jst0{fill-rule:evenodd;clip-rule:evenodd;fill:none;}\r\n\t.jst1{fill-rule:evenodd;clip-rule:evenodd;fill:currentColor;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -1.43,
    y: -0.82,
    className: "jst0",
    width: 360,
    height: 360
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "jst1",
    d: "M66.38,63.06h94.89v91.89H66.38V63.06L66.38,63.06z M50.77,18.06c-7.31,0-14.01,3.01-18.86,7.85l-0.03,0.03 c-4.85,4.85-7.85,11.54-7.85,18.86v268.75c0,7.34,3.01,14.02,7.84,18.87l0.03,0.03c4.84,4.83,11.53,7.85,18.87,7.85h255.61 c7.33,0,14.02-3.01,18.87-7.85l0.03-0.03c4.83-4.85,7.85-11.53,7.85-18.87V44.8c0-7.32-3.01-14.01-7.85-18.86l-0.03-0.03 c-4.85-4.85-11.54-7.85-18.86-7.85H50.77L50.77,18.06z M306.38,33.16H50.77c-3.21,0-6.13,1.31-8.21,3.4l-0.03,0.03 c-2.09,2.08-3.4,5-3.4,8.21v268.75c0,3.2,1.3,6.12,3.39,8.22l0.03,0.03c2.11,2.09,5.02,3.39,8.22,3.39h255.61 c3.2,0,6.12-1.3,8.22-3.39l0.03-0.03c2.09-2.11,3.39-5.02,3.39-8.22V44.8c0-3.21-1.31-6.13-3.4-8.21l-0.03-0.03 C312.51,34.47,309.59,33.16,306.38,33.16L306.38,33.16z M201.61,201.09h94.9v91.89h-94.9V201.09L201.61,201.09z M66.38,201.48h94.89 v91.89H66.38V201.48L66.38,201.48z M201.61,62.68h94.9v91.89h-94.9V62.68z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTile);
export default __webpack_public_path__ + "static/media/tile.4d9577d8e0fc838c133f1d28f98cad83.svg";
export { ForwardRef as ReactComponent };